<template>
  <div class="mobile-side-nav">
    <div class="mobile-nav-container">
      <div class="nav-header">
        <div class="nav-logo">
          <img
            src="@/assets/img/neobank.png"
            alt="Site Logo"
            srcset
            height="40"
            width="auto"
												data-test="categoryNavMobileImg1"
          >
        </div>
        <div
          class="nav-close"
          @click="closesidebar"
										data-test="categoryNavMobileClose"
        >
          <div class="icon icon--ei-navicon icon--s">
            <svg
              id="navbar-close-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
														data-test="categoryNavMobileCloseSvg"
            >
              <path d="M37.304 11.282l1.414 1.414-26.022 26.02-1.414-1.413z" />
              <path d="M12.696 11.282l26.022 26.02-1.414 1.415-26.022-26.02z" />
            </svg>
          </div>
        </div>
      </div>

      <div class="mobile-scroll">
        <ul class="nav-section">
          <li
            class="category-nav-wrapper"
            v-for="(category, index) in getCategoryData"
            :key="index"
          >
            <a
              href=""
              class="ripplelink"
              @click="mobilemenutoggle"
														:data-test="'categoryNavMobileName'+index"
            >
              {{category.category_name}}
            </a>
            <div
              class="nav-dropdown-wrapper"
              style="display: none"
            >
              <ul class="sub-category">
                <li class="list-header">
                  <a
                    href=""
                    class="mobile-goback ripplelink"
                    @click="goback"
																				data-test="categoryNavMobileBackLink1"
                  >
                    <i class="fas fa-arrow-left"
																							data-test="categoryNavMobileBackIcon1"></i>
                    Back
                  </a>
                </li>
                <li>
                  <a
                    href=""
                    @click.prevent="getCategory(category, 1)"
                    class="ripplelink view-all"
																				:data-test="'categoryNavMobileAllCategoryName'+index"
                  >
                    All {{category.category_name}} Products
                  </a>
                </li>
                <li
                  v-for="(subCategory, key) in category.sub_categories"
                  :key="key"
                >
                  <a
                    href=""
                    class="ripplelink"
                    @click="mobilemenutoggle"
																				:data-test="'categoryNavMobileSubCategoryName'+key"
                  >
                    {{subCategory.category_name}}
                  </a>
                  <div
                    class="nav-dropdown-wrapper"
                    style="display: none"
                  >
                    <ul class="sub-category">
                      <li class="list-header">
                        <a
                          href=""
                          class="mobile-goback ripplelink"
                          @click="goback"
																										data-test="categoryNavMobileBackLink2"
                        >
                          <i class="fas fa-arrow-left"
																													data-test="categoryNavMobileBackIcon2"></i>
                          Back
                        </a>
                      </li>
                      <li>
                        <a
                          href=""
                          @click.prevent="getCategory(subCategory, 2)"
                          class="ripplelink view-all"
																										:data-test="'categoryNavMobileAllSubCategoryName'+key"
                        >
                          All {{subCategory.category_name}} Products
                        </a>
                      </li>
                      <li
                        v-for="(brand, id) in subCategory.sub_categories"
                        :key="id"
                      >
                        <a
                          href
                          @click.prevent="getCategory(brand, 3)"
																										:data-test="'categoryNavMobileBrandName'+id"
                        >
                          {{brand.category_name}}
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <ul class="nav-section border-top">
          <li
            class="category-nav-wrapper"
            v-if="isAuthenticated"
          >
            <router-link
              class="ripplelink"
              :to="{
              path :'/user/account',
              query: {
                display_text: 'My Account',
              }}"
              @click.native="closesidebar"
														data-test="categoryNavMobileAccountLink"
            >
              <i class="fas fa-user-check"
																	data-test="categoryNavMobileAccountIcon"></i>
              My Account
            </router-link>
            <router-link
              class="ripplelink"
              :to="{
                path :'/cart',
                query: {
                  display_text: 'My Cart',
                }
              }"
              @click.native="closesidebar"
														data-test="categoryNavMobileCartLink"
            >
              <i class="fas fa-shopping-cart"
																	data-test="categoryNavMobileCartIcon"></i>
              My Cart
            </router-link>
            <router-link
              class="ripplelink"
              :to="{
              path :'/user/orders',
              query: {
                display_text: 'My Orders',
              }}"
              @click.native="closesidebar"
														data-test="categoryNavMobileOrderLink"
            >
              <i class="fas fa-cart-arrow-down"
																	data-test="categoryNavMobileOrderIcon"></i>
              My Orders
            </router-link>
            <router-link
              class="ripplelink"
              :to="{
              path :'/user/wish-list',
              query: {
                display_text: 'My Wishlist',
              }}"
              @click="mobilemenutoggle"
              @click.native="closesidebar"
														data-test="categoryNavMobileWishlistLink"
            >
              <i class="fas fa-heart"
																	data-test="categoryNavMobileWishlistIcon"></i>
              My Wishlist
            </router-link>
            <router-link
              v-if="isAuthenticated"
              class="ripplelink"
              to=""
              @click.native="logOut"
														data-test="categoryNavMobileLogoutLink"
            >
              <i class="fas fa-sign-out-alt"
																	data-test="categoryNavMobileLogoutIcon"></i>
              Logout
            </router-link>
          </li>
          <div v-else>
          <li
            class="category-nav-wrapper"
          >
            <router-link
              class="ripplelink"
              :to="{
              path :'/login'}"
              @click.native="closesidebar"
														data-test="categoryNavMobileSignInLink"
            >
              <i class="fas fa-user"
																	data-test="categoryNavMobileSignInIcon"></i>
              Sign in
            </router-link>
          </li>
          <li
            class="category-nav-wrapper"
          >
            <router-link
              class="ripplelink"
              :to="{
              path :'/vendorLogin'}"
              @click.native="closesidebar"
            >
              <i class="fas fa-user-tie"></i>
              Merchant Registration
            </router-link>
          </li>
          </div>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authenticationApi } from '../../../../services/ApiServices/authenticationApi'

export default {
	computed: {
		...mapGetters('category', ['getCategoryData']),
		...mapGetters('user', ['isAuthenticated'])
	},
	methods: {
		mobileCategoryReset () {
			const className = document.getElementsByClassName('nav-dropdown-wrapper')
			for (const key in className) {
				if (className[key] && className[key].style && className[key].style.display) {
					className[key].style.display = 'none'
				}
			}
		},
		mobilemenutoggle (e) {
			e.preventDefault()
			setTimeout(() => {
				const target = e.target.nextElementSibling

				if (target.style.display === 'none') {
					target.style.display = 'block'
					document.querySelector('body').classList.add('stop-scroll')
				} else {
					target.style.display = 'none'
					document.querySelector('body').classList.remove('stop-scroll')
				}
			}, 500)
		},
		goback (e) {
			e.preventDefault()
			setTimeout(() => {
				const target = e.target.closest('.nav-dropdown-wrapper')

				if (target.style.display === 'none') {
					target.style.display = 'block'
				} else {
					target.style.display = 'none'
				}
			}, 500)
		},
		closesidebar () {
			// eslint-disable-next-line quotes
			this.mobileCategoryReset()
			document.querySelector('.mobile-side-nav').classList.remove('shown')
			document.querySelector('body').classList.remove('stop-scroll')
			document.querySelector('#mainApp').classList.remove('backdrop')
		},
		getCategory (classifications, depth) {
			this.mobileCategoryReset()
			// const keyWord = {
			//   category_id: classifications.category_id,
			//   is_a_category: true };
			// productApi.getSearchProducts(keyWord)
			//   .then((res) => {
			//     if (res) {
			this.$nextTick(() => {
				this.$router.push({
					name: 'ProductList',
					path: '/product-list',
					query: {
						category: classifications.category_id,
						depth,
						name: classifications.category_name,
						display_text: classifications.category_name,
						is_a_category: true
					}
				})
				this.closesidebar()
			})
		},
		logOut () {
			this.closesidebar()
			authenticationApi.logOut().then((res) => {
				this.$router.push('/')
			})
		}
	}
}
</script>

<style>
</style>
